export default __webpack_public_path__ + "static/media/create-disabled.49b67ff4.svg";